// extracted by mini-css-extract-plugin
export default {"dropButton":"DownloadPDF_dropButton__5+5xV"};